export default "__VITE_ASSET__0dd7eec5__"